import React from 'react';
import { NAV_COMPONENT, SuiteId } from '~/constants';
import NavigationBar from '../navigation-bar';
import { compact, find } from '~/utils';
import { corpUserStore } from '~/models';

interface SuiteNavigationBarProps {
    isSysAdmin: boolean;
    suiteId: SuiteId;
}

const SuiteNavigationBar: React.FC<SuiteNavigationBarProps> = (props) => {
    const { isSysAdmin, suiteId } = props;
    // suiteId 对应的 navigationModule 不存在时(eg.普通成员访问套件开启页)，不渲染 defaultMenu
    const defaultMenu = find(corpUserStore.navigationModules, ['suiteId', suiteId])?.key || '';

    return (
        <NavigationBar
            className="fx-suite-navigation-bar"
            defaultMenu={defaultMenu}
            right={[compact([isSysAdmin && NAV_COMPONENT.CONTACTS, NAV_COMPONENT.PROFILE])]}
        />
    );
};

export default SuiteNavigationBar;
